import { create } from 'zustand'
import { getCookie, eraseCookie } from '@/utils/cookies'
import { isTokenExpired } from '@/utils/authUtils'
import { COOKIE_NAMES } from '@/constants/auth'

interface AuthState {
    isAuthenticated: boolean
    loading: boolean
    setAuth: (flag: boolean) => void
    initAuth: () => void
    logout: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
    isAuthenticated: false,
    loading: true,

    // 🌟 Only update isAuthenticated, do NOT modify loading here!
    setAuth(flag) {
        set({ isAuthenticated: flag })
    },

    // 🔥 Runs at app load to validate cookie/token
    initAuth() {
      console.log("Initializing auth state...")
        set({ loading: true })
        const token = getCookie(COOKIE_NAMES.ACCESS_TOKEN)

        if (token && !isTokenExpired(token)) {
            set({ isAuthenticated: true, loading: false })
        } else {
            eraseCookie(COOKIE_NAMES.ACCESS_TOKEN)
            set({ isAuthenticated: false, loading: false })
        }
    },

    // 🚪 Safe logout without full reload
    logout() {
        eraseCookie(COOKIE_NAMES.ACCESS_TOKEN)
        set({ isAuthenticated: false })
        // Navigate with SPA, not full reload
        window.history.pushState({}, '', '/login')
    }
}))
